import { Story } from '../../DocTypes';

export const buttonAfterTextStory: Story = {
  title: 'Buttons after text',
  description: 'List with items buttons displayed after the right text',
  coreComponent: {
    html: `<tag-list
    primary-field='name'
    right-field-1='description'
    button-1-icon='Edit'
    button-1-rounded
    button-2-icon='View'
    button-2-rounded
    button-1-host-style='{"order": "1"}'
    button-2-host-style='{"order": "2"}'>
  </tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      {
        name: 'Jordan Norry',
        description: 'Some stuff',
      },
      {
        name: 'Sarah Young',
        description: 'Some stuff',
      },
      {
        name: 'Susan Warmly',
        description: 'Some stuff',
      }
    ]);
  });
  `,
  },
  reactWrapper: {
    jsx: `<TagList
    primaryField='name'
    rightField1='description'
    button1Icon='Edit'
    button1Rounded
    button2Icon='View'
    button2Rounded
    button1HostStyle={{order: "1"}}
    button2HostStyle={{order: "2"}}
    data={[
      {
        name: 'Jordan Norry',
        description: 'Some stuff',
      },
      {
        name: 'Sarah Young',
        description: 'Some stuff',
      },
      {
        name: 'Susan Warmly',
        description: 'Some stuff',
      }
    ]}
  />`,
  },
};
